export function isClientFacingAuthRoute(path: string, source?: string | null): boolean {
    return path === '/auth/client-login'
        || path === '/auth/reset-password'
        || path === '/accept-client-invite'
        || (
            (path === '/auth/mfa' || path === '/auth/completing-sign-in')
            && source === 'client-login'
        );
}

export function shouldFetchPublicWorkspaceContextForAuth(path: string): boolean {
    return path === '/auth/login'
        || path === '/auth/signup'
        || path === '/auth/verify-email'
        || path === '/auth/forgot-password'
        || path === '/auth/reset-password'
        || path === '/auth/mfa'
        || path === '/auth/completing-sign-in'
        || path === '/auth/client-login'
        || path === '/accept-client-invite';
}

export function isClientFacingSurface(path: string, source?: string | null): boolean {
    return path.startsWith('/portal')
        || path.startsWith('/public/')
        || path.startsWith('/forms/')
        || isClientFacingAuthRoute(path, source);
}
